import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=2b4e4754&scoped=true&"
import script from "./Sobre.vue?vue&type=script&lang=js&"
export * from "./Sobre.vue?vue&type=script&lang=js&"
import style0 from "./Sobre.vue?vue&type=style&index=0&id=2b4e4754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e4754",
  null
  
)

export default component.exports